import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { UpdateUserModel, GetUserModel } from 'src/app/viewModels/users/UserListModel';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { CommonService } from 'src/app/middleware/common/common.service';
//import { RoleService } from 'src/app/applicationModules/roles/services/role.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  updateUserDetailform: FormGroup;
  updateUserDetail: UpdateUserModel = new UpdateUserModel();
  getUserDetail: GetUserModel = new GetUserModel();
  titleAlert = 'This field is required';
  isEdit: boolean;
  user: any;
  hide = true;
  roles: any[];
  phoneNumberExt: string;
  updateUserResponseHolder: any;
  rolesResponseHolder: any;
  getUserListModelEdit={
    search : '',
    pageSize: 10000,
    pageIndex: 0,
    databaseID: 0,
    organizationID: 0
  }
  @Output() closeSidePanel = new EventEmitter();
  constructor(
    private formBuilder: FormBuilder,
    private customValidator: CustomvalidationService,
    private _userService: UserService, private commonService: CommonService,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private paginationVm: PaginationViewModel,
    private _dataSharingService: DataSharingService,
    private loaderService: LoaderService, private toastr: ToastrService,
    private statusConst: StatusConstant) {
      this.getUserListModelEdit.databaseID = parseInt(sessionStorage.getItem('databaseId'));
      this.getUserListModelEdit.organizationID = parseInt(sessionStorage.getItem('organizationID'));
      this.getRolesList();
      let data = [];
      data = this.commonService.getEditData();
      this.isEdit = data[0];
      this.user = data[1];
    this.updateUserDetail.UUID = this.user.uuid;
    this.updateUserDetail.FirstName = this.user.firstName;
    this.updateUserDetail.LastName = this.user.lastName;
    this.phoneNumberExt = this.user.phoneNumber.substring(0, 2);
    this.updateUserDetail.PhoneNumber = this.user.phoneNumber.substring(2);
    this.updateUserDetail.UserRoles = this.user.tempUserRole.split(',');
    this.updateUserDetail.isActive = this.user.isActive;
    this.updateUserDetail.isActive = this.user.isActive === 'Active' ? true : false;
    this.generateForm();
  }
  ngOnInit(): void {
    // this.roles = [
    //   'Admin' , 'Super Admin' ,
    // ];
  }

  generateForm() {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.updateUserDetailform = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)]],
      userRoles: ['', Validators.required],
      isActive: ''
    });

  }

  get name() {
    return this.updateUserDetailform.get('name') as FormControl;
  }

  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.updateUserDetailform);
  }

  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.updateUserDetailform);
  }
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.updateUserDetailform);
  }

  equals(objOne, objTwo) {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne === objTwo;
    }
  }

  // To allow only alphabets on FirstName and LastName
  checkregex() {
    if (!this.updateUserDetailform.controls['firstname'].value.match(/^[a-zA-Z ]+$/) &&
    this.updateUserDetailform.controls['firstname'].value !== '') {
      this.updateUserDetailform.controls['firstname'].setValue("");
    } else if (!this.updateUserDetailform.controls['lastname'].value.match(/^[a-zA-Z ]+$/) &&
    this.updateUserDetailform.controls['lastname'].value !== '') {
      this.updateUserDetailform.controls['lastname'].setValue("");
    }
    this.titleAlert = 'Please enter only alphabets';
  }


  async updateUser() {
    const updateSelectedDetail = new UpdateUserModel();
    try {
      updateSelectedDetail.UUID = this.updateUserDetail.UUID;
      updateSelectedDetail.PhoneNumber =  this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.phoneNumberExt + '' + this.updateUserDetail.PhoneNumber);
      updateSelectedDetail.FirstName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.updateUserDetail.FirstName);
      updateSelectedDetail.LastName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.updateUserDetail.LastName);
      updateSelectedDetail.UserRoles = this.updateUserDetail.UserRoles;    
      updateSelectedDetail.isActive = (this.updateUserDetail.isActive !== true) ? false : this.updateUserDetail.isActive;
      this.loaderService.show();
      const result = await this._userService.updateUser(updateSelectedDetail).toPromise();
      this.updateUserResponseHolder = result;
      this.loaderService.hide();
      if (this.updateUserResponseHolder.status === this.statusConst.statusSuccess) {
        this.toastr.success("Updated successfully.", '', {
          timeOut: 3000,
        });
        let closePanel = false;
        this.closeSidePanel.emit(closePanel);
        this._dataSharingService.sendClickEvent();
      } else {
        this.toastr.error("Error with code:" + '' + this.updateUserResponseHolder.status + '' + ", and with message:" + '' + this.updateUserResponseHolder.message, '', {
          timeOut: 3000,
        });
      }
    } catch (e) {
      Observable.throw(e);
    }
  }

  getUserDetailbyId(data: GetUserModel) {
    this._userService.getUserDetail(data).subscribe(result => {
      this.updateUserDetail.FirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, result.data.firstName);
      this.updateUserDetail.LastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, result.data.lastName);
      this.updateUserDetail.PhoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, result.data.phoneNumber);
      this.updateUserDetail.isActive = result.data.isActive;
      this.generateForm();
    });
  }


  close() {
    let closePanel = false;
    this.closeSidePanel.emit(closePanel);
  }

  getRolesList(){
    this.loaderService.show();
    // this.rolesService.getRoleList(this.getUserListModelEdit).subscribe(response=>{
    //  if (response) {
    //   this.rolesResponseHolder = response;
    //   if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {
    //     this.roles = this.rolesResponseHolder.data.roleModel;
    //     this.loaderService.hide();      
    //   }
    // }
    // });
  
  }

}

